import { render } from "./CollectionStoreFormView.vue?vue&type=template&id=064f3160&scoped=true"
import script from "./CollectionStoreFormView.vue?vue&type=script&lang=js"
export * from "./CollectionStoreFormView.vue?vue&type=script&lang=js"

import "./CollectionStoreFormView.vue?vue&type=style&index=0&id=064f3160&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064f3160"]])

export default __exports__